module.exports = __webpack_public_path__ + "static/media/CarynHealth Logo.bf181469.png";